import { useLayoutEffect, useRef, useState } from 'react';
import * as ReactDOM from 'react-dom/client';
import { useThree } from '@react-three/fiber';

export const useHtmlMount = (
  as = 'div',
  portal?: React.RefObject<HTMLElement>,
  prepend?: boolean,
  enabled = true,
) => {
  const { gl, events } = useThree();
  const target = (portal?.current || events.connected || gl.domElement.parentNode) as HTMLElement;

  const [el] = useState(() => document.createElement(as));
  const root = useRef<ReactDOM.Root>(null);

  useLayoutEffect(() => {
    if (!enabled) return;
    root.current = ReactDOM.createRoot(el);
    if (prepend) {
      target.prepend(el);
    } else {
      target.append(el);
    }
    return () => {
      root.current?.unmount();
      target.removeChild(el);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target, prepend]);

  return { el, root, target };
};
